import {Component, OnInit} from '@angular/core';
import {Document} from '../documents/document-countries/document-countries.component';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
})
export class PrivacyPolicyComponent implements OnInit {

  countries: Array<Document> = [
    {
      countryName: 'Россия',
      img: 'ru.svg',
      docHref: 'privacy-policy.html'
    },
    {
      countryName: 'Казахстан',
      img: 'kz.svg',
      docHref: 'privacy-policy-kz.html'
    },
    {
      countryName: 'Кыргызстан',
      img: 'kg.svg',
      docHref: 'privacy-policy-kg.html'
    },
    {
      countryName: 'Беларусь',
      img: 'by.svg',
      docHref: 'privacy-policy-by.html'
    },
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

}
